function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.crypto || (window.crypto = window.msCrypto);

var t = function t() {
  var t;

  try {
    t = function () {
      for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 21, e = "", r = crypto.getRandomValues(new Uint8Array(t)); t--;) {
        var n = 63 & r[t];
        e += n < 36 ? n.toString(36) : n < 62 ? (n - 26).toString(36).toUpperCase() : n < 63 ? "_" : "-";
      }

      return e;
    }(36);
  } catch (e) {
    t = Date.now() + Math.random().toString(36).slice(2);
  }

  return t;
},
    e = t();

function r(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function n(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}

function o(t, e, r) {
  return e && n(t.prototype, e), r && n(t, r), t;
}

function i(t) {
  return (i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  })(t);
}

var a = {
  exports: {}
};
!function (t) {
  var e = function (t) {
    var e,
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        a = o.iterator || "@@iterator",
        s = o.asyncIterator || "@@asyncIterator",
        c = o.toStringTag || "@@toStringTag";

    function u(t, e, r) {
      return Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }

    try {
      u({}, "");
    } catch (t) {
      u = function u(t, e, r) {
        return t[e] = r;
      };
    }

    function f(t, e, r, n) {
      var o = e && e.prototype instanceof g ? e : g,
          i = Object.create(o.prototype),
          a = new P(n || []);
      return i._invoke = function (t, e, r) {
        var n = l;
        return function (o, i) {
          if (n === d) throw new Error("Generator is already running");

          if (n === m) {
            if ("throw" === o) throw i;
            return I();
          }

          for (r.method = o, r.arg = i;;) {
            var a = r.delegate;

            if (a) {
              var s = k(a, r);

              if (s) {
                if (s === v) continue;
                return s;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === l) throw n = m, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = d;
            var c = h(t, e, r);

            if ("normal" === c.type) {
              if (n = r.done ? m : p, c.arg === v) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (n = m, r.method = "throw", r.arg = c.arg);
          }
        };
      }(t, r, a), i;
    }

    function h(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = f;
    var l = "suspendedStart",
        p = "suspendedYield",
        d = "executing",
        m = "completed",
        v = {};

    function g() {}

    function y() {}

    function w() {}

    var b = {};

    b[a] = function () {
      return this;
    };

    var O = Object.getPrototypeOf,
        S = O && O(O(L([])));
    S && S !== r && n.call(S, a) && (b = S);

    var _ = w.prototype = g.prototype = Object.create(b);

    function E(t) {
      ["next", "throw", "return"].forEach(function (e) {
        u(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }

    function x(t, e) {
      function r(o, a, s, c) {
        var u = h(t[o], t, a);

        if ("throw" !== u.type) {
          var f = u.arg,
              l = f.value;
          return l && "object" === i(l) && n.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
            r("next", t, s, c);
          }, function (t) {
            r("throw", t, s, c);
          }) : e.resolve(l).then(function (t) {
            f.value = t, s(f);
          }, function (t) {
            return r("throw", t, s, c);
          });
        }

        c(u.arg);
      }

      var o;

      this._invoke = function (t, n) {
        function i() {
          return new e(function (e, o) {
            r(t, n, e, o);
          });
        }

        return o = o ? o.then(i, i) : i();
      };
    }

    function k(t, r) {
      var n = t.iterator[r.method];

      if (n === e) {
        if (r.delegate = null, "throw" === r.method) {
          if (t.iterator["return"] && (r.method = "return", r.arg = e, k(t, r), "throw" === r.method)) return v;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var o = h(n, t.iterator, r.arg);
      if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
      var i = o.arg;
      return i ? i.done ? (r[t.resultName] = i.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, v) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
    }

    function T(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function j(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function P(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(T, this), this.reset(!0);
    }

    function L(t) {
      if (t) {
        var r = t[a];
        if (r) return r.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var o = -1,
              i = function r() {
            for (; ++o < t.length;) {
              if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
            }

            return r.value = e, r.done = !0, r;
          };

          return i.next = i;
        }
      }

      return {
        next: I
      };
    }

    function I() {
      return {
        value: e,
        done: !0
      };
    }

    return y.prototype = _.constructor = w, w.constructor = y, y.displayName = u(w, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === y || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, u(t, c, "GeneratorFunction")), t.prototype = Object.create(_), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, E(x.prototype), x.prototype[s] = function () {
      return this;
    }, t.AsyncIterator = x, t.async = function (e, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new x(f(e, r, n, o), i);
      return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, E(_), u(_, c, "Generator"), _[a] = function () {
      return this;
    }, _.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e.reverse(), function r() {
        for (; e.length;) {
          var n = e.pop();
          if (n in t) return r.value = n, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, t.values = L, P.prototype = {
      constructor: P,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(j), !t) for (var r in this) {
          "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var r = this;

        function o(n, o) {
          return s.type = "throw", s.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i],
              s = a.completion;
          if ("root" === a.tryLoc) return o("end");

          if (a.tryLoc <= this.prev) {
            var c = n.call(a, "catchLoc"),
                u = n.call(a, "finallyLoc");

            if (c && u) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (c) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];

          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), v;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), v;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];

          if (r.tryLoc === t) {
            var n = r.completion;

            if ("throw" === n.type) {
              var o = n.arg;
              j(r);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, r, n) {
        return this.delegate = {
          iterator: L(t),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = e), v;
      }
    }, t;
  }(t.exports);

  try {
    regeneratorRuntime = e;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(e);
  }
}(a);
var s = a.exports;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function c(t, e, r, n) {
  return new (r || (r = Promise))(function (o, i) {
    function a(t) {
      try {
        c(n.next(t));
      } catch (t) {
        i(t);
      }
    }

    function s(t) {
      try {
        c(n["throw"](t));
      } catch (t) {
        i(t);
      }
    }

    function c(t) {
      var e;
      t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
        t(e);
      })).then(a, s);
    }

    c((n = n.apply(t, e || [])).next());
  });
}

var u = {
  development: "http://datatest.hiido.com/c.gif",
  production: "https://shop.eclytics.com/j.gif"
},
    f = u.production,
    h = u.development,
    l = "1.1.2";

function p(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var r = 0, n = new Array(e); r < e; r++) {
    n[r] = t[r];
  }

  return n;
}

function d(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

    if (null != r) {
      var n,
          o,
          i = [],
          a = !0,
          s = !1;

      try {
        for (r = r.call(t); !(a = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); a = !0) {
          ;
        }
      } catch (t) {
        s = !0, o = t;
      } finally {
        try {
          a || null == r["return"] || r["return"]();
        } finally {
          if (s) throw o;
        }
      }

      return i;
    }
  }(t, e) || function (t, e) {
    if (t) {
      if ("string" == typeof t) return p(t, e);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? p(t, e) : void 0;
    }
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

var m = function () {
  function t() {
    r(this, t);
    var e = navigator.userAgent;
    this.ua = e, this.os = this.detectOS(this.ua), this.os_version = this.detectOSVersion(this.ua, this.os), this.browser = this.detectBrowser(this.ua), this.browser_version = this.detectBrowserVersion(this.ua, this.browser);
  }

  return o(t, [{
    key: "detectOS",
    value: function value(t) {
      switch (!0) {
        case /Android/.test(t):
          return "Android";

        case /iPhone|iPad|iPod/.test(t):
          return "iOS";

        case /Windows/.test(t):
          return "Windows";

        case /Mac OS X/.test(t):
          return "Mac";

        case /CrOS/.test(t):
          return "Chrome OS";

        case /Firefox/.test(t):
          return "Firefox OS";
      }

      return "";
    }
  }, {
    key: "detectOSVersion",
    value: function value(t, e) {
      switch (e) {
        case "Android":
          return this.getVersion(t, "Android");

        case "iOS":
          return this.getVersion(t, /OS /);

        case "Windows":
          return this.getVersion(t, /Phone/.test(t) ? /Windows Phone (?:OS )?/ : /Windows NT/);

        case "Mac":
          return this.getVersion(t, /Mac OS X /);
      }

      return "0.0.0";
    }
  }, {
    key: "getVersion",
    value: function value(t, e) {
      try {
        return this.normalizeSemverString(t.split(e)[1].trim().split(/[^\w.]/)[0]);
      } catch (t) {}

      return "0.0.0";
    }
  }, {
    key: "normalizeSemverString",
    value: function value(t) {
      var e = t.split(/[._]/);
      return (parseInt(e[0], 10) || 0) + "." + (parseInt(e[1], 10) || 0) + "." + (parseInt(e[2], 10) || 0);
    }
  }, {
    key: "detectBrowser",
    value: function value(t) {
      var e = /Android/.test(t);

      switch (!0) {
        case /CriOS/.test(t):
          return "Chrome for iOS";

        case /Edge/.test(t):
          return "Edge";

        case e && /Silk\//.test(t):
          return "Silk";

        case /Chrome/.test(t):
          return "Chrome";

        case /Firefox/.test(t):
          return "Firefox";

        case e:
          return "AOSP";

        case /MSIE|Trident/.test(t):
          return "IE";

        case /Safari\//.test(t):
          return "Safari";

        case /AppleWebKit/.test(t):
          return "WebKit";
      }

      return "";
    }
  }, {
    key: "detectBrowserVersion",
    value: function value(t, e) {
      switch (e) {
        case "Chrome for iOS":
          return this.getVersion(t, "CriOS/");

        case "Edge":
          return this.getVersion(t, "Edge/");

        case "Chrome":
          return this.getVersion(t, "Chrome/");

        case "Firefox":
          return this.getVersion(t, "Firefox/");

        case "Silk":
          return this.getVersion(t, "Silk/");

        case "AOSP":
          return this.getVersion(t, "Version/");

        case "IE":
          return /IEMobile/.test(t) ? this.getVersion(t, "IEMobile/") : /MSIE/.test(t) ? this.getVersion(t, "MSIE ") : this.getVersion(t, "rv:");

        case "Safari":
          return this.getVersion(t, "Version/");

        case "WebKit":
          return this.getVersion(t, "WebKit/");
      }

      return "0.0.0";
    }
  }]), t;
}();

function v() {
  var t,
      e,
      r,
      n,
      o,
      i,
      a,
      s,
      c = "link_monitor_is_first_day",
      u = window.localStorage.getItem(c);
  return u ? (t = new Date(+u), e = t.getFullYear(), r = t.getMonth(), n = t.getDate(), o = new Date(), i = o.getFullYear(), a = o.getMonth(), s = o.getDate(), e === i && r === a && n === s) : (window.localStorage.setItem(c, Date.now() + ""), !0);
}

function g(t, e) {
  var r = new Image(1, 1),
      n = function (t) {
    if ("object" !== i(t)) return "";
    var e = [];

    for (var r in t) {
      if (Object.prototype.hasOwnProperty.call(t, r)) {
        var n = encodeURIComponent(t[r]);
        e.push("".concat(r, "=").concat(n));
      }
    }

    return e.join("&");
  }(e),
      o = "".concat(t, "?").concat(n);

  r.onerror = function () {
    console.log("linkMonitor: fail to get img");
  }, r.onload = function () {}, r.src = o;
}

function y(t, e) {
  return (y = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function w(t, e) {
  return !e || "object" !== i(e) && "function" != typeof e ? function (t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }(t) : e;
}

function b(t) {
  return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function O() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function S(t, e, r) {
  return (S = O() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && y(o, r.prototype), o;
  }).apply(null, arguments);
}

function _(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (_ = function _(t) {
    if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
    var r;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, n);
    }

    function n() {
      return S(t, arguments, b(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), y(n, t);
  })(t);
}

function E(t) {
  var e = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }();

  return function () {
    var r,
        n = b(t);

    if (e) {
      var o = b(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);

    return w(this, r);
  };
}

var x = function (t) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && y(t, e);
  }(n, _(Error));
  var e = E(n);

  function n(t) {
    var o;
    return r(this, n), (o = e.call(this, t)).name = "LinkMonitorError", o.message = "[LinkMonitorError]: " + t || "[LinkMonitorError]: Error", o;
  }

  return n;
}(),
    k = function () {
  function t(e, n) {
    var o = this;
    if (r(this, t), this.act = "", this.url = "", this.defaultOptions = {}, this.queue = [], this.queueIsRIFScheduled = !1, this.upload = function (t) {
      if (o.queueIsRIFScheduled = !1, t || (t = {
        didTimeout: !0,
        timeRemaining: function timeRemaining() {
          return Number.MAX_VALUE;
        }
      }), (null == t ? void 0 : t.timeRemaining()) > 0 || o.queue.length > 0) {
        var e = o.queue.shift();
        e && g(e.reportUrl, e.reportData);
      }

      o.queue.length > 0 && o.upload();
    }, !e) throw new x("Core类初始化需要act字段");
    if (!n) throw new x("Core类初始化需要url字段");
    this.act = e, this.url = n, this.getDefaultOptions();
  }

  return o(t, [{
    key: "getDefaultOptions",
    value: function value() {
      var t,
          r = this.act,
          n = l,
          o = {
        bs_ua: (t = new m()).ua,
        bs_os: t.os,
        bs_os_version: t.os_version,
        bs_browser: t.browser,
        bs_browser_version: t.browser_version
      },
          i = {
        bs_screen_height: window.screen.height,
        bs_screen_width: window.screen.width,
        bs_color_depth: window.screen.colorDepth.toString()
      },
          a = window.navigator.javaEnabled().toString(),
          s = new Date().getTimezoneOffset().toString(),
          c = window.navigator.language;
      this.defaultOptions = Object.assign(Object.assign(Object.assign({
        pvId: e,
        act: r,
        bs_lib_plugin_version: n
      }, o), i), {
        bs_java_enabled: a,
        bs_time_zone_offset: s,
        bs_language: c
      });
    }
  }, {
    key: "getDefaultDynamicOptions",
    value: function value() {
      var t = Date.now(),
          e = Math.floor(t / 1e3),
          r = document.title,
          n = window.location.href,
          o = document.referrer,
          i = v(),
          a = {
        bs_viewport_height: document.documentElement.offsetHeight || document.body.offsetHeight,
        bs_viewport_width: document.documentElement.offsetWidth || document.body.offsetWidth
      };
      return {
        time: e,
        bs_create_time: t,
        bs_title: r,
        bs_url: n,
        bs_referrer: o,
        bs_is_first_day: i,
        bs_viewport_height: a.bs_viewport_height,
        bs_viewport_width: a.bs_viewport_width
      };
    }
  }, {
    key: "send",
    value: function value(t, e) {
      var r = this.getDefaultDynamicOptions(),
          n = Object.assign(Object.assign(Object.assign(Object.assign({}, this.defaultOptions), r), {
        eventName: t
      }), e);
      this.queue.push({
        reportUrl: this.url,
        reportData: n
      }), this.queueUpload();
    }
  }, {
    key: "queueUpload",
    value: function value() {
      var t, e;
      this.queueIsRIFScheduled || (this.queueIsRIFScheduled = !0, t = this.upload, e = {
        timeout: 2e3
      }, "requestIdleCallback" in window ? window.requestIdleCallback(t, e) : setTimeout(t, 0));
    }
  }]), t;
}();

function T(t) {
  return t < 0 ? 0 : t;
}

var j = function j() {
  return new Promise(function (t) {
    for (var e, r, n = (e = {
      redirectTime: -1,
      dnsTime: -1,
      ttfbTime: -1,
      appcacheTime: -1,
      unloadTime: -1,
      tcpTime: -1,
      reqTime: -1,
      analysisTime: -1,
      blankTime: -1,
      domReadyTime: -1
    }, r = window.performance.timing, e.redirectTime = T(r.redirectEnd - r.redirectStart), e.dnsTime = T(r.domainLookupEnd - r.domainLookupStart), e.ttfbTime = T(r.responseStart - r.navigationStart), e.appcacheTime = T(r.domainLookupStart - r.fetchStart), e.unloadTime = T(r.unloadEventEnd - r.unloadEventStart), e.tcpTime = T(r.connectEnd - r.connectStart), e.reqTime = T(r.responseEnd - r.responseStart), e.analysisTime = T(r.domComplete - r.domInteractive), e.blankTime = T((r.domInteractive || r.domLoading) - r.fetchStart), e.domReadyTime = T(r.domContentLoadedEventEnd - r.fetchStart), e), o = Object.assign(Object.assign({}, n), {
      FMP: -1,
      LCP: -1,
      FID: -1
    }), i = setTimeout(function () {
      return t(o);
    }, 5e3), a = 0, s = [new Promise(function (t) {
      if (!window.PerformanceObserver) return t({
        FMP: -1
      });

      try {
        new PerformanceObserver(function (e, r) {
          var n,
              o = e.getEntries()[0];
          r.disconnect(), t({
            FMP: null !== (n = o.renderTime) && void 0 !== n ? n : o.startTime
          });
        }).observe({
          entryTypes: ["element"]
        });
      } catch (e) {
        return console.log("Error: can not getFMP"), t({
          FMP: -1
        });
      }
    }), new Promise(function (t) {
      if (!window.PerformanceObserver) return t({
        LCP: -1
      });

      try {
        new PerformanceObserver(function (e, r) {
          var n,
              o = e.getEntries(),
              i = o[o.length - 1];
          r.disconnect(), t({
            LCP: null !== (n = i.renderTime) && void 0 !== n ? n : i.startTime
          });
        }).observe({
          entryTypes: ["largest-contentful-paint"]
        });
      } catch (e) {
        return console.log("Error: can not getLCP"), t({
          LCP: -1
        });
      }
    }), new Promise(function (t) {
      if (!window.PerformanceObserver) return t({
        FID: -1
      });

      try {
        new PerformanceObserver(function (e, r) {
          var n = e.getEntries()[0];
          n && (r.disconnect(), t({
            FID: n.processingStart - n.startTime
          }));
        }).observe({
          type: "first-input",
          buffered: !0
        });
      } catch (e) {
        return console.log("Error: can not getFID"), t({
          FID: -1
        });
      }
    })], c = 0; c < s.length; c++) {
      Promise.resolve(s[c]).then(function (e) {
        if (e instanceof Object && (o = Object.assign(Object.assign({}, o), e)), (a += 1) == s.length) return clearTimeout(i), t(o);
      })["catch"](function () {});
    }
  });
};

var P = function () {
  function t(e, n) {
    r(this, t), this.performanceFEDLOG = e, this.businessDefaultOptions = n;
  }

  return o(t, [{
    key: "init",
    value: function value() {
      return c(this, void 0, void 0, s.mark(function t() {
        return s.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return this.tempInitPromise = this.getPerformanceData(), t.abrupt("return", this.tempInitPromise);

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "getPerformanceData",
    value: function value() {
      var t = this;
      return new Promise(function (e) {
        var r;
        r = function r() {
          return c(t, void 0, void 0, s.mark(function t() {
            var r, n;
            return s.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, j();

                  case 2:
                    return r = t.sent, n = Object.assign(Object.assign({}, this.businessDefaultOptions), r), this.reportData = n, t.abrupt("return", e(n));

                  case 6:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }, "complete" === document.readyState ? r() : window.addEventListener("load", r);
      });
    }
  }, {
    key: "send",
    value: function value() {
      return c(this, void 0, void 0, s.mark(function t() {
        return s.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.reportData) {
                  t.next = 2;
                  break;
                }

                throw new x("please set await init() first");

              case 2:
                this.performanceFEDLOG.send("performance", this.reportData), this.tempInitPromise = void 0;

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "startRender",
    value: function value() {
      void 0 !== this.startTime && console.warn("linkMonitor: You have already used startRender, are you sure to continue using it?"), this.startTime = Date.now();
    }
  }, {
    key: "endRender",
    value: function value() {
      return c(this, void 0, void 0, s.mark(function t() {
        var e, r;
        return s.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (!this.isGetData) {
                  t.next = 5;
                  break;
                }

                return console.warn("you have got timing data"), t.abrupt("return");

              case 5:
                this.isGetData = !0;

              case 6:
                if (void 0 !== this.startTime) {
                  t.next = 8;
                  break;
                }

                throw new x("you must use startRender first");

              case 8:
                return this.endTime = Date.now(), e = this.endTime - this.startTime, t.next = 12, this.tempInitPromise;

              case 12:
                return r = t.sent, this.reportData = Object.assign(Object.assign({}, r), {
                  FMP: e
                }), t.next = 16, this.send();

              case 16:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }]), t;
}(),
    L = {
  debug: !1,
  reportUrl: f,
  performance: !1
},
    I = function () {
  function t(n, o) {
    r(this, t), this.pvId = e, this.businessDefaultOptions = {
      version: "0.0.0",
      environment: "production"
    }, this.act = n, this.options = Object.assign(Object.assign({}, L), o), this.options.debug && (this.options.reportUrl = h), this.fedLog = new k(n, this.options.reportUrl), this.options.performance && (this.timingRecord = this.getTiming(), !0 === this.options.performance || "auto" === this.options.performance ? this.autoGetTiming() : "manual" === this.options.performance && this.manualGetTiming());
  }

  return o(t, [{
    key: "init",
    value: function value(t) {
      this.businessDefaultOptions = Object.assign(Object.assign({}, this.businessDefaultOptions), t);
    }
  }, {
    key: "report",
    value: function value(t, e) {
      if (!this.options.reportUrl) throw new x("miss report url");

      var r = function (t) {
        return Object.entries(t).reduce(function (t, e) {
          var r = d(e, 2),
              n = r[0],
              o = r[1];
          return t[n] = o instanceof Object ? JSON.stringify(o) : o, t;
        }, {});
      }(e),
          n = Object.assign(Object.assign({}, this.businessDefaultOptions), r);

      this.fedLog.send(t, n);
    }
  }, {
    key: "getTiming",
    value: function value() {
      if (this.options.performance) {
        if (!this.options.reportUrl) throw new x("miss report url");
        var t = new k("webpaymentfeperformance", this.options.reportUrl);
        return new P(t, this.businessDefaultOptions);
      }
    }
  }, {
    key: "autoGetTiming",
    value: function value() {
      return c(this, void 0, void 0, s.mark(function t() {
        return s.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord) {
                  t.next = 2;
                  break;
                }

                return t.abrupt("return");

              case 2:
                return t.next = 4, this.timingRecord.init();

              case 4:
                return t.next = 6, this.timingRecord.send();

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "manualGetTiming",
    value: function value() {
      return c(this, void 0, void 0, s.mark(function t() {
        return s.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord) {
                  t.next = 2;
                  break;
                }

                return t.abrupt("return");

              case 2:
                return t.next = 4, this.timingRecord.init();

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "startRecord",
    value: function value() {
      return c(this, void 0, void 0, s.mark(function t() {
        return s.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord && "manual" === this.options.performance) {
                  t.next = 2;
                  break;
                }

                throw new x("did you set performance to 'manual'?");

              case 2:
                this.timingRecord.startRender();

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "endRecord",
    value: function value() {
      return c(this, void 0, void 0, s.mark(function t() {
        return s.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord && "manual" === this.options.performance) {
                  t.next = 2;
                  break;
                }

                throw new x("did you set performance to 'manual'?");

              case 2:
                this.timingRecord.endRender();

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }]), t;
}();

export { I as Monitor, t as getPvId, e as pvId };